import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from '../../messages';

const buildSigningMethodSection = ({
  canSignElectronically = false,
  isPendingResidentApplicant = false,
  formatMessage,
}: {
  canSignElectronically: boolean,
  isPendingResidentApplicant: boolean,
  formatMessage: Function,
}) => {
  return {
    name: 'signingMethodSection',
    container: 'default',
    title: 'APPLICATION SIGNING METHOD',
    titleVariant: 'subsection',
    border: true,
    fields: [
      {
        name: 'signingMethod',
        variant: 'singleSelect',
        label: 'Signing Method',
        placeholder: 'Select',
        options: [
          ...(canSignElectronically
            ? [
                {
                  value: 'electronic',
                  text: 'Electronic Signing',
                  ...(isPendingResidentApplicant
                    ? {
                        disabled: true,
                        tooltip: formatMessage(
                          messages.pendingResidentElectronicSigningTooltip,
                        ),
                      }
                    : {}),
                },
              ]
            : []),
          {
            value: 'manual',
            text: 'Manual Signing',
          },
        ],
        rules: {
          required: true,
          validate: (value) =>
            isPendingResidentApplicant && value === 'electronic'
              ? formatMessage(messages.pendingResidentElectronicSigningInvalid)
              : true,
        },
        GridProps: {
          xs: 12,
          md: 6,
        },
      },
      {
        variant: 'custom',
        component: (
          <Typography variant="bodyMedium" color="text.secondary">
            NOTE: Choose how the applicant will sign this form. If manual
            signing is selected, you will be able to upload the completed
            application. If electronic signing is chosen, you will be able to
            send to the applicant’s portal account and the signed copy will
            automatically be added to the household documents. Please note that
            electronic signing may not be available for all properties.
          </Typography>
        ),
      },
    ],
  };
};

export default buildSigningMethodSection;
